// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_hK1","cls2":"ReferenceReportPage-cls2_4dh ReferenceReportPage-cls1_hK1"};